import Fallback from '@/components/Fallback';

import {
    QueryStHistoryRecord,
} from '@/services/teacher';

import {Col, Form, Row, Table} from 'antd';
import React from 'react';
import {useParams} from "react-router-dom";
import useAsync from "@/hooks/useAsync";

export default function HistoryStRecord() {


    const [form] = Form.useForm();

    const params = useParams<{ id: string}>();

    const userID = parseInt(params.id);


    const listState = useAsync(
        () => QueryStHistoryRecord(userID),
        [userID]
    );


    return (
        <Fallback
            state={listState}
            render={( data) => (
                <>
                    <div  style={{'fontSize': '20px','fontWeight':'bold'}}>
                    {data.map((item,i)=>{
                        if (i==0){
                            return(
                                <Row>
                                    <Col xs={16}>{item.userName}:练习统计</Col>
                                </Row>
                            )
                        }
                    })}
                    </div>

                    <Table
                        title={() => (
                                <div  style={{'fontSize': '15px'}}>
                                    {data.map((item,i)=>{
                                        if (i==0){
                                            return(
                                                <Row >
                                                    开课日:<Col style={{ color: `#FF0000`}} xs={16}>{item.startTime}</Col>
                                                </Row>
                                            )
                                        }
                                    })}
                                </div>
                        )}
                        rowKey="id"
                        bordered
                        size="small"
                        style={{ minWidth: '100%' }}
                        dataSource={data}
                        pagination={ false }
                        columns={[
                            {
                                dataIndex: 'weekName',
                                title: '#',
                            },
                            {
                                dataIndex: 'weekTime_',
                                title: '周统计',
                                render: (value) => (
                                    value === -1 ? (
                                        `进行中`
                                    ) : (
                                        <span><span  style={{ color: `#FF0000`}} >{value}</span><span>分钟</span></span>
                                    )
                                ),
                            },
                            {
                                dataIndex: 'monthTime_',
                                title: '月统计',
                                render: (value) => (
                                    value <= 0 ? (
                                        ''
                                    ) : (
                                        <span><span  style={{ color: `#FF0000`}} >{value}</span><span>分钟</span></span>
                                    )
                                ),
                            },
                            {
                                dataIndex: 'weekLimit',
                                title: '周期',
                            },

                        ]}
                    />
                </>
            )}
        />
    );
}
// 颖嘉98 72
// 夏毓96.5 78
// 熙玉98.5 72.5
// 筠琦93.5 67.5
// 诗瑶94 72
// 琪玉98.5 72.5
// 沫桦95 69
// 凌伊 100 90
// 熙瑶 94 68
// 梦嘉 98 72
// 馥菲 100 74

